<script setup lang="ts">
/**
 * CDB54 Calendrier+ - Update Notification Component
 * Story 4.2: Notification when app update is available
 */

import { useI18n } from 'vue-i18n';
import { usePwa } from '@/composables/usePwa';

const { t } = useI18n();
const { needsRefresh, updateServiceWorker } = usePwa();

async function handleUpdate(): Promise<void> {
  await updateServiceWorker();
}

function dismissUpdate(): void {
  needsRefresh.value = false;
}
</script>

<template>
  <Transition name="slide-up">
    <div v-if="needsRefresh" class="update-notification" role="alert">
      <div class="update-content">
        <i class="bi bi-arrow-repeat me-2"></i>
        <span>{{ t('pwa.update_available') }}</span>
      </div>
      <div class="update-actions">
        <button class="btn btn-sm btn-light" @click="dismissUpdate">
          {{ t('pwa.later') }}
        </button>
        <button class="btn btn-sm btn-primary ms-2" @click="handleUpdate">
          {{ t('pwa.update_now') }}
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.update-notification {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: #0d6efd;
  color: #fff;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  z-index: 1060;
  max-width: 90%;
  width: auto;
}

.update-content {
  display: flex;
  align-items: center;
}

.update-actions {
  display: flex;
  align-items: center;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translate(-50%, 100%);
}
</style>
